import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import React from 'react';
import { Form, Input, RadioGroup, RadioItem } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { ETagType } from 'src/types/common/customerDb';
import css from './css.module.less';
import CountWords from '@/src/components/CountWords/CountWords';
import { get } from 'lodash';

const Item = Form.Item;
export { ETagType };
const Setting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  return (
    <SectionWrapper title={getI18n('customerTag.settings.customerTagSettings')}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <Item
                    shouldUpdate={(p, c) => {
                      const pV = get(p, 'title');
                      const cV = get(c, 'title');
                      return cV !== pV;
                    }}>
                    {({ getFieldValue }) => {
                      const t = getFieldValue('title') || '';
                      return (
                        <CountWords count={(t || '').length} allCount={100} />
                      );
                    }}
                  </Item>
                }
                title={getI18n('customerTag.settings.customerTagTitle*')}>
                <Item
                  name='title'
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        'customerTag.settings.pleasefillthetitle',
                      ),
                    },
                  ]}>
                  <Input maxLength={100} size='large' disabled={disabled} />
                </Item>
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n('customerTag.settings.customerTagType')}>
                <Item
                  name='tagType'
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        'customerTag.tagCondition.pleaseselectatype',
                      ),
                    },
                  ]}>
                  <RadioGroup className={css.group} disabled={disabled}>
                    <RadioItem className={css.item} value={ETagType.Manual}>
                      {getI18n('customerTag.settings.manualTag')}
                    </RadioItem>
                    <RadioItem value={ETagType.Auto}>
                      {getI18n('customerTag.settings.autoTag')}
                    </RadioItem>
                  </RadioGroup>
                </Item>
              </ItemWrapper>
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};
export default Setting;
